import React, { useState, useEffect, useCallback } from 'react';
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import '../../css/Mypage/changePwd.css';
import { apiPost } from '../../utils/api';

const PasswordInput = ({ label, id, value, onChange, required, placeholder, error, touched, isPasswordType }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className='form-group'>
      <label htmlFor={id}>{label}</label>
      <div className='input-with-icon'>
        <input
          type={showPassword ? 'text' : 'password'}
          id={id}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => { setIsFocused(false); setShowPassword(false); }}
          required={required}
          placeholder={placeholder}
          autoComplete="off"
        />
        {isPasswordType && isFocused && value && (
          <span className='password-toggle-icon' onMouseDown={(e) => { e.preventDefault(); setShowPassword(prev => !prev); }}>
            {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
          </span>
        )}
      </div>
      {touched && error && <p className='error-message'>{error}</p>}
    </div>
  );
};

function ChangePwd() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [currentPasswordError, setCurrentPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmNewPasswordError, setConfirmNewPasswordError] = useState('');

  const [touched, setTouched] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [formIsValid, setFormIsValid] = useState(false);

  const validateForm = useCallback(() => {
    let valid = true;
    let currentErr = '', newErr = '', confirmErr = '';

    if (!currentPassword) {
      currentErr = '현재 비밀번호를 입력하세요.';
      valid = false;
    }

    if (!newPassword || !/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={};:'"\\|,.<>/?]).{8,}$/.test(newPassword)) {
      newErr = '영문, 숫자, 특수문자 포함 8자 이상이어야 합니다.';
      valid = false;
    }

    if (newPassword !== confirmNewPassword) {
      confirmErr = '비밀번호가 일치하지 않습니다.';
      valid = false;
    }

    setCurrentPasswordError(currentErr);
    setNewPasswordError(newErr);
    setConfirmNewPasswordError(confirmErr);

    return valid;
  }, [currentPassword, newPassword, confirmNewPassword]);

  useEffect(() => {
    setFormIsValid(validateForm());
  }, [currentPassword, newPassword, confirmNewPassword, validateForm]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ current: true, new: true, confirm: true });

    if (!validateForm()) return;

    try {
      const res = await apiPost('/member/changePassword.php', {
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password : confirmNewPassword
      });

      if (res.result === 'success') {
        alert('비밀번호가 변경되었습니다.');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
        setTouched({ current: false, new: false, confirm: false });
      } else {
        setCurrentPasswordError(res.reason || '비밀번호 변경 실패');
      }
    } catch (err) {
      console.error('에러:', err);
      alert('서버 오류가 발생했습니다.');
    }
  };

  return (
    <div className='change-user-password'>
      <form onSubmit={handleSubmit}>
        <PasswordInput
          label='현재 비밀번호'
          id='current-password'
          value={currentPassword}
          onChange={(e) => { setCurrentPassword(e.target.value); setTouched(t => ({ ...t, current: true })); }}
          required
          placeholder='현재 비밀번호 입력'
          error={currentPasswordError}
          touched={touched.current}
        />
        <PasswordInput
          label='새 비밀번호'
          id='new-password'
          value={newPassword}
          onChange={(e) => { setNewPassword(e.target.value); setTouched(t => ({ ...t, new: true })); }}
          required
          placeholder='새 비밀번호 입력'
          error={newPasswordError}
          touched={touched.new}
          isPasswordType
        />
        <PasswordInput
          label='새 비밀번호 확인'
          id='confirm-new-password'
          value={confirmNewPassword}
          onChange={(e) => { setConfirmNewPassword(e.target.value); setTouched(t => ({ ...t, confirm: true })); }}
          required
          placeholder='새 비밀번호 재입력'
          error={confirmNewPasswordError}
          touched={touched.confirm}
          isPasswordType
        />
        <button type='submit' className='change-btn btn' disabled={!formIsValid}>비밀번호 변경</button>
      </form>
    </div>
  );
}

export default ChangePwd;
